import React, { useContext, useEffect, useMemo } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import Yes from "../../../../../images/ApprovedStatus.svg";
import No from "../../../../../images/RejectedStatus.svg";
import { Button } from "../../../../../stories/Button/Button";
import { optionsType } from "../../../../../utils/formTypes";
import { GetItemNodeForStockEntryViewAsset } from "../../masters/items/queries/queries";
import { useLazyQuery } from "@apollo/client";
import { AtsStckItem } from "../../masters/items/queries/types";
import { nodeVar } from "../../../../../utils/commonQueryTypes";
import useToken from "../../../../../customHooks/useToken";
import { StockEntryContext } from "./Add/context/context";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const ViewConfiguration = ({ setModalFlag }: Props) => {
  const [GetItem, { data }] = useLazyQuery<{ node: AtsStckItem }, nodeVar>(
    GetItemNodeForStockEntryViewAsset
  );

  const { handleToken } = useToken();

  const { dispatch, state } = useContext(StockEntryContext);
  const assetConfigurations: optionsType[] = [
    { label: "Track Serial", value: "trackSerial" },
    { label: "Track Brand", value: "trackBrand" },
    { label: "Track Model", value: "trackModel" },
    { label: "Track Batch", value: "trackBatch" },
    { label: "Track Expiry", value: "trackExpiry" },
    { label: "Track Warranty", value: "trackWarranty" },
    { label: "Track Installation", value: "trackInstallation" },
    { label: "Track Maintenance", value: "trackMaintenance" },
    { label: "Is Perishable", value: "isPerishable" },
    { label: "Is Consumable", value: "isConsumable" },
    { label: "Image Needed", value: "imageNeeded" },
    { label: "Track AMC", value: "trackAmc" },
    { label: "Track Geo Location", value: "trackGeoLocation" },
    { label: "Track Insurance", value: "trackInsurance" },
    { label: "Is Module", value: "isModule" },
    { label: "Is Component", value: "isComponent" },
    {
      label: "Stock Details Entry Not Needed",
      value: "stckDetailsEntryNotNeeded",
    },
    {
      label: "Stock Details Entry Is Single",
      value: "stckDetailsEntryIsSingle",
    },
    {
      label: "Stock Details Entry Is Multiple",
      value: "stckDetailsEntryIsMultiple",
    },
    { label: "Additional Property Needed", value: "additionalPropertyNeeded" },
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await handleToken();
        if (token && state.itm) {
          GetItem({
            variables: {
              id: state.itm.value,
              token,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };

    fetchData();
  }, [GetItem, state.itm, data]);

  const enabledConfigs = useMemo(() => {
    return assetConfigurations.filter((config) => {
      if (data) {
        return (data.node as unknown as Record<string, boolean>)[
          `${config.value}`
        ];
      } else {
        return false;
      }
    });
  }, [data, assetConfigurations]);

  return (
    <>
      <div className="stock-entry-config">
        <div className="stock-entry-config__title">
          <Title>View Configurations Enabled and Disabled</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <ul className="stock-entry-config__ul">
          {data
            ? enabledConfigs.map((config, index) => {
                return (
                  <li>
                    <span>
                      {index + 1}. {config.label}.
                    </span>
                    <div>
                      <img src={Yes} alt="" /> Yes
                    </div>
                  </li>
                );
              })
            : null}
        </ul>
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default ViewConfiguration;
